import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './initialState';

const RolesStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default RolesStore;
